package ui.app.rss.channel

import androidx.compose.animation.*
import androidx.compose.animation.core.*
import androidx.compose.foundation.*
import androidx.compose.foundation.layout.*
import androidx.compose.foundation.lazy.*
import androidx.compose.foundation.shape.*
import androidx.compose.material3.*
import androidx.compose.runtime.*
import androidx.compose.ui.*
import androidx.compose.ui.draw.*
import androidx.compose.ui.graphics.vector.*
import androidx.compose.ui.text.style.*
import androidx.compose.ui.unit.*
import androidx.compose.ui.util.*
import api.*
import common.frontend.api.*
import compose.assets.*
import compose.assets.svg.*
import io.*
import kotlinx.coroutines.*
import kotlinx.datetime.*
import org.ssoft.common.tools.*
import provider.*
import ssoft.frontend.generated.resources.*
import tk.mallumo.utils.*
import tools.*
import ui.resource.*
import ui.widget.*
import kotlin.time.Duration.Companion.milliseconds


@Composable
fun AppRssListingChannelScope.RssChannelCreatorDialog(dialogState: DialogState) {
    Dialog(dialogState) {
        val entry = remember {
            AppRssListingChannelScope.Wrapper.Item(Io.ListingRssChannel.Item.EMPTY)
        }
        val state = remember {
            mutableDataState<api.org.ssoft.server.common.rss.Io.Rss>()
        }

        val scope = rememberCoroutineScope()
        val actionNext: @Composable () -> Unit = {
            TextButton(
                onClick = {
                    scope.launch {
                        state.value = DataState.Loading()
                        runCatching {
                            Repository.api.rss.preview(entry.url.state.trim())
                        }.onSuccess {
                            state.value = DataState.Result(it)
                        }.onFailure {
                            state.value = DataState.Error(it.message!!, throwable = it)
                        }
                    }
                },
                enabled = entry.name.err.not() && entry.url.err.not()
            ) {
                Text(Res.string.dialog__action_next.rememberString())
            }
        }
        val actionConfirm: @Composable () -> Unit = {
            TextButton(
                onClick = {
                    action(AppRssListingChannelVM.Action.New(entry.data))
                    dialogState.hide()
                },
            ) {
                Text(Res.string.dialog__action_ok.rememberString())
            }
        }
        val actionBack: @Composable () -> Unit = {
            TextButton(
                onClick = {
                    state.value = DataState.Idle()
                },
            ) {
                Text(Res.string.dialog__action_back.rememberString())
            }
        }
        DialogUI(
            modifier = Modifier.fillMaxWidth(),
            onDismissRequest = { dialogState.hide() },
            title = {
                Text(Res.string.layer_bottom_rss_channels_item_title_create.rememberString())
            },
            dismissButton = {
                TextButton({ dialogState.hide() }) {
                    Text(Res.string.dialog__action_cancel.rememberString())
                }
            },
            confirmButton = {
                Crossfade(state.value) {
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        when (it) {
                            is DataState.Error -> {
                                actionBack()
                            }

                            is DataState.Idle -> {
                                actionNext()
                            }

                            is DataState.Loading -> Unit
                            is DataState.Result -> {
                                actionBack()
                                actionConfirm()
                            }
                        }
                    }
                }

            }) {
            Crossfade(state.value) {
                when (it) {
                    is DataState.Error -> Text(it.message)
                    is DataState.Idle -> CreatorContent(entry, true)
                    is DataState.Loading -> Box(Modifier.fillMaxWidth()) {
                        CircularProgressIndicator(
                            Modifier.align(Alignment.Center)
                                .padding(24.dp)
                        )
                    }

                    is DataState.Result -> RssFeedContent(it.nnvl)
                }
            }

        }
    }
}

@Composable
fun AppRssListingChannelScope.RssChannelEditDialog(
    dialogState: DialogState,
    originItem: AppRssListingChannelScope.Wrapper.Item
) {
    Dialog(dialogState) {
        val entry = remember {
            AppRssListingChannelScope.Wrapper.Item(originItem.data.copy())
        }
        val state = remember {
            mutableDataState<api.org.ssoft.server.common.rss.Io.Rss>()
        }

        val scope = rememberCoroutineScope()

        val actionNext: @Composable () -> Unit = {
            TextButton(
                onClick = {
                    scope.launch {
                        state.value = DataState.Loading()
                        runCatching {
                            Repository.api.rss.preview(entry.url.state.trim())
                        }.onSuccess {
                            state.value = DataState.Result(it)
                        }.onFailure {
                            state.value = DataState.Error(it.message!!, throwable = it)
                        }
                    }
                },
                enabled = (entry.name.err.not() && entry.url.err.not())
            ) {
                Text(Res.string.dialog__action_next.rememberString())
            }
        }
        val actionConfirm: @Composable () -> Unit = {
            TextButton(
                onClick = {
                    action(AppRssListingChannelVM.Action.Edit(entry.data))
                    dialogState.hide()
                },
                enabled = (entry.name.err.not() && entry.url.err.not())
                    && (entry.name.change || entry.url.change || entry.interval.change)
            ) {
                Text(Res.string.dialog__action_save.rememberString())
            }
        }
        val actionBack: @Composable () -> Unit = {
            TextButton(
                onClick = {
                    state.value = DataState.Idle()
                },
            ) {
                Text(Res.string.dialog__action_back.rememberString())
            }
        }
        DialogUI(
            modifier = Modifier.fillMaxWidth(),
            onDismissRequest = { dialogState.hide() },
            title = {
                Text(Res.string.layer_bottom_rss_channels_item_title_edit.rememberString())
            },
            dismissButton = {
                TextButton({ dialogState.hide() }) {
                    Text(Res.string.dialog__action_cancel.rememberString())
                }
            },
            confirmButton = {
                Crossfade(state.value) {
                    Row(horizontalArrangement = Arrangement.spacedBy(8.dp)) {
                        when (it) {
                            is DataState.Error -> {
                                actionBack()
                            }

                            is DataState.Idle -> {
                                actionNext()
                            }

                            is DataState.Loading -> Unit
                            is DataState.Result -> {
                                actionBack()
                                actionConfirm()
                            }
                        }
                    }
                }

            }) {
            Crossfade(state.value) {
                when (it) {
                    is DataState.Error -> Text(it.message)
                    is DataState.Idle -> CreatorContent(entry, false)
                    is DataState.Loading -> Box(Modifier.fillMaxWidth()) {
                        CircularProgressIndicator(
                            Modifier.align(Alignment.Center)
                                .padding(24.dp)
                        )
                    }

                    is DataState.Result -> RssFeedContent(it.nnvl)
                }
            }

        }
    }
}

@Composable
private fun RssFeedContent(nnvl: api.org.ssoft.server.common.rss.Io.Rss) {
    val externals = LocalExternalsProvider.current

    LazyColumn(
        Modifier.fillMaxSize(),
        verticalArrangement = Arrangement.spacedBy(8.dp)
    ) {
        items(nnvl.item) {
            RssItemUi(it, externals)
        }
    }
}

@Composable
private fun RssItemUi(item: api.org.ssoft.server.common.rss.Io.RssEntry, externals: CommonExternalsProvider) {
    Card {
        Column(
            verticalArrangement = Arrangement.spacedBy(4.dp),
            modifier = Modifier.padding(4.dp)
        ) {
            RssItemLine(Svg.Key, item.guid)
            RssItemLine(Svg.Image, item.content.url) {
                externals.openInBrowser(item.content.url)
            }
            RssItemLine(Svg.Format_text, item.title)
            RssItemLine(Svg.Text_long, item.description)
            RssItemLine(Svg.Web, item.link) {
                externals.openInBrowser(item.link)
            }
            RssItemLine(Svg.Shape, item.category)
            RssItemLine(Svg.Account, item.author)
            RssItemLine(Svg.Calendar, buildString {
                append("Create: ${item.pubDate.date.takeIf { it != LocalDate.EMPTY } ?: " NONE "}")
                append("; Change: ${item.changeDate.date.takeIf { it != LocalDate.EMPTY } ?: " NONE "}")
                append("; End: ${item.endDate.date.takeIf { it != LocalDate.EMPTY } ?: " NONE "}")
            })
            RssItemAssets(item, externals)
        }
    }
}

@Composable
private fun RssItemAssets(item: api.org.ssoft.server.common.rss.Io.RssEntry, externals: CommonExternalsProvider) {
    var areMediaVisible by remember {
        mutableStateOf(false)
    }
    RssItemLine(Svg.Multimedia, "${item.enclosure.size}x") {
        areMediaVisible = !areMediaVisible
    }
    AnimatedVisibility(areMediaVisible) {
        Column(
            Modifier.padding(start = 16.dp),
            verticalArrangement = Arrangement.spacedBy(4.dp),
        ) {
            item.enclosure.forEach {
                if (ResourceType.TEXT match it.resourceType) {
                    RssItemLine(Svg.Text_long, it.description)
                } else {
                    RssItemLine(ResourceType.rememberIcon(it.resourceType), it.name.takeIf { it.isNotEmpty() } ?: it.url) {
                        externals.openInBrowser(it.url)
                    }
                }
            }
        }
    }
}

@Composable
private fun RssItemLine(icon: ImageVector, text: String, onClick: (() -> Unit)? = null) {
    Row(horizontalArrangement = Arrangement.spacedBy(8.dp),
        modifier = Modifier.let { if (onClick == null || text.trim().isEmpty()) it else it.clickable { onClick() } }) {
        Icon(
            imageVector = icon,
            contentDescription = null
        )
        Text(
            text = text.trim().takeIf { it.isNotEmpty() } ?: " - ",
            modifier = Modifier.fillMaxWidth(),
            maxLines = 1,
            overflow = TextOverflow.Ellipsis
        )
    }
}

@Composable
private fun CreatorContent(entry: AppRssListingChannelScope.Wrapper.Item, creatorMode: Boolean) {
    Column(verticalArrangement = Arrangement.spacedBy(16.dp)) {
        NameField(entry)
        UrlField(entry, creatorMode)
        IntervalField(entry)

    }

}

@Composable
private fun UrlField(entry: AppRssListingChannelScope.Wrapper.Item, creatorMode: Boolean) {
    TextField(
        value = entry.url.text,
        readOnly = !creatorMode,
        leadingIcon = { Icon(Svg.Www, null) },
        isError = entry.url.err,
        onValueChange = { entry.url.set(it) },
        label = { Text(Res.string.layer_bottom_rss_channels_item_field_www.rememberString()) },
        modifier = Modifier.fillMaxWidth()
    )
}

@Composable
private fun NameField(entry: AppRssListingChannelScope.Wrapper.Item) {
    TextField(
        value = entry.name.text,
        isError = entry.name.err,
        leadingIcon = { Icon(Svg.Format_text, null) },
        onValueChange = { entry.name.set(it) },
        label = { Text(Res.string.layer_bottom_rss_channels_item_field_name.rememberString()) },
        modifier = Modifier.fillMaxWidth()
    )
}

@Composable
private fun IntervalField(entry: AppRssListingChannelScope.Wrapper.Item) {
    var isExpanded by remember {
        mutableStateOf(false)
    }
    val animation by animateFloatAsState(
        animationSpec = tween(200),
        targetValue = if (isExpanded) 180F
        else 0F
    )
    Card(
        onClick = { isExpanded = true },
        shape = RoundedCornerShape(topStart = 8.dp, topEnd = 8.dp)
    ) {
        Row(
            horizontalArrangement = Arrangement.spacedBy(16.dp),
            modifier = Modifier.fillMaxWidth()
                .padding(horizontal = 12.dp, vertical = 16.dp)
        ) {
            Icon(Svg.Clock_outline, null)
            Text(
                text = Res.string.layer_bottom_rss_channels_item_field_interval.rememberString(),
                style = MaterialTheme.typography.titleMedium
            )
            Text(
                text = entry.interval.state.milliseconds.toString(),
                style = MaterialTheme.typography.titleMedium,
                textAlign = TextAlign.End,
                modifier = Modifier.weight(1F)
            )
            Spacer(Modifier.weight(1F))
            Icon(
                imageVector = Svg.Chevron_down,
                contentDescription = null,
                modifier = Modifier
                    .align(Alignment.CenterVertically)
                    .rotate(animation)
            )
        }
        DropdownMenu(
            expanded = isExpanded,
            modifier = Modifier.clip(CardDefaults.shape),
            onDismissRequest = { isExpanded = false }) {
            AppRssListingChannelScope.Wrapper.Item.intervals
                .fastForEach { value ->
                    DropdownMenuItem(
                        text = {
                            Text(
                                value.toString(),
                                modifier = Modifier.fillMaxWidth()
                            )
                        },
                        onClick = {
                            entry.interval.set(value.inWholeMilliseconds)
                            isExpanded = false
                        })
                }
        }
    }
}
